import React, { Component } from 'react';
import Arrow from '../assets/icons/drop.svg';
import {getCountryWithTimezone} from '../assets/json/timezones';
import Ng from '../assets/svg/nig.svg';
import { get } from "../util/axiosLib";
import './css/pc.css';


export default class pickCountryNumber extends Component {

    state = {
        allCountries: [],
        countryChoice: "Nigeria",
        countryCode: this.props.defaultCode ?? "+234",
        detectedCountry: {
            CountryCode: this.props.defaultCode ?? "+234",
        }
    }

    loadCountries = async () => {
        try {
            const getCountries = await get(
                `https://restcountries.eu/rest/v2/all`
            );
            const allCountries = getCountries.data;
            const codesAndFlags = allCountries.map(item => {
                return {
                    callCode: `+${item.callingCodes[0]}`,
                    flag: item.flag,
                    countryCode: item.alpha3Code,
                    code: item.numericCode
                }
            }).sort(function(a, b) {
                let keyA = a.countryCode.toLowerCase(),
                    keyB = b.countryCode.toLowerCase();
                // Compare the 2 country codes
                if (keyA < keyB) return -1;
                if (keyA > keyB) return 1;
                return 0;
            })
            localStorage.setItem("countryCode", "+234")

            const detectedCountry = this.detectCountry();

            // if(!this.props.defaultCode && ) {
            if(detectedCountry.CountryCode) {
                const imgFlag = document.querySelector('.pc-selected3 img.ctry-flag');
                if(imgFlag) {
                    const ctryFlag = codesAndFlags.filter((cF) => cF.callCode === detectedCountry.CountryCode);
                    if(ctryFlag && ctryFlag[0] && ctryFlag[0].flag) {
                        imgFlag.src = ctryFlag[0].flag;
                        localStorage.setItem("countryCode", detectedCountry.CountryCode)
                        this.setState({detectedCountry: {...detectedCountry, CountryCode: detectedCountry.CountryCode}});
                        if(this.props.handleCountryPicker) this.props.handleCountryPicker(detectedCountry.CountryCode) 
                    }
                }
            } 

            this.setState({
                allCountries: codesAndFlags
            });
        } catch (err) {
            //const errData = err.response;
        }
    }
    detectCountry = () => {
        const tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        const ctry = getCountryWithTimezone(tz);

        return ctry;
    }
    async componentDidMount() {
        const selected = document.querySelector(".pc-selected3")
        const optionsContainer = document.querySelector(".pc-options-container3")
        const optionsList = document.querySelectorAll(".pc-option3");

        if (optionsList !== undefined) {
            console.log(optionsList)
        }

        selected.addEventListener("click", () => {
            optionsContainer.classList.toggle("active");
        })

        optionsList.forEach(opt => {
            opt.addEventListener("click", () => {
                selected.innerHTML = opt.querySelector("label").innerHTML;
                optionsContainer.classList.remove("active");
            });
        });

        await this.loadCountries();
    }

    handleChoice = async (event) => {
        //event.preventDefault()

        const selected = document.querySelector(".pc-selected3")
        const optionsList = document.querySelectorAll(".pc-option3");
        const optionsContainer = document.querySelector(".pc-options-container3")

        await optionsList.forEach(opt => {
            opt.addEventListener("click", () => {
                selected.innerHTML = opt.querySelector("label").innerHTML;
                //opt.querySelector("input").checked = true; //line that selects the radio button when the div is clicked
                optionsContainer.classList.remove("active");
                const optn = opt.querySelector("span").innerHTML;
                //console.log(optn.substr(3))
                localStorage.setItem("countryCode", optn.substr(3))
                if(this.props.handleCountryPicker) this.props.handleCountryPicker(optn.substr(3))
                //console.log(localStorage.getItem("countryCode"))
            });
        });
    }


    render() {
        const {detectedCountry} = this.state;
        return (
            <div className="pc3-section">
                <div className="pc-box3">
                    <div className="pc-options-container3">
                        {this.state.allCountries.map((country) => (
                            <div className="pc-option3" key={country.code} onClick={this.handleChoice}>
                                <input type="radio"
                                       className="radio"
                                    //    id="country"
                                       name="country"
                                       value={country.callCode}
                                />
                                <label htmlFor={country.name} className="flex-opt">
                                    <img className="country-sm" src={country.flag} alt=""/>
                                    <span className="opt-number">
                                    {country.countryCode + " " + country.callCode}
                                </span>
                                </label>
                            </div>
                        ))}


                        {/* 
                        <div className="pc-option3">
                            <input type="radio" 
                            className="radio" 
                            id="jets" 
                            name="category" 
                            />
                            <label htmlFor="jets" className="flex-opt">
                                <img src={Gh} alt=""/>
                                <span className="opt-number">+233</span>
                            </label>
                        </div> */}
                    </div>

                    <div className="pc-selected3">
                        <div className="flex-opt">
                            <img src={Ng} alt="" className="country-sm ctry-flag"/>
                            <span className="opt-number right-m3">{detectedCountry.CountryCode}</span>
                            <img src={Arrow} alt="" className="country-sm"/>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

